<organization-top-navbar></organization-top-navbar>
<div class="inline-block py-4 padding-left-1-2rem">
  <button class="gap-2 flex items-center" (click)="(goBack())">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
      class="size-6 stroke-[#0D6EFD]">
      <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
    </svg>
    @if(additionalServicesEnabled) {
      <p class=" font-medium text-sm text-[#0D6EFD]">{{'PARKIFLY.BACK_BUTTONS.BACK_TO_SERVICES' | transloco}}</p>
      }@else {
      <p class=" font-medium text-sm text-[#0D6EFD]">{{'PARKIFLY.BACK_BUTTONS.BACK_TO_PARKINGS' | transloco}}</p>
    }
  </button>
</div>
<div class="Content w-full lg:px-28 px-4 justify-start items-start gap-8  flex xl:flex-row flex-col" #detailsHeading
  id="details-page-content">
  @if(!isParkingPermitUser) {
    <div class="Frame808 flex-col justify-start items-start gap-4 inline-flex w-full">
      <div class="Frame802 self-stretch flex-col justify-start items-start gap-4 flex">
        <div class="DinaUppgifter text-black text-lg font-bold  leading-loose">{{'PARKIFLY.DETAILS.DETAILS' |
        transloco}}</div>
        <div
          class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
          <div class="Frame799 self-stretch justify-start items-start flex flex-col lg:flex-row">
            <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex w-full">
              @if(this.site.toLowerCase() == 'tui' || this.site.toLowerCase() == 'nazar') {
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 lg:border-r border-b border-zinc-200 justify-start items-start gap-2.5 flex text-sm font-medium ">
                  <pf-text-input label="{{'PARKIFLY.FORM.ORDER_NUMBER' | transloco}}"
                    [inputFormControl]="this.detailsGroup.controls.firstname"
                  class="w-full"></pf-text-input>
                </div>
                }@else {
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 lg:border-r border-b border-zinc-200 justify-start items-start gap-2.5 flex text-sm font-medium ">
                  <pf-text-input label="{{'PARKIFLY.FORM.FIRST_NAME' | transloco}}"
                    [inputFormControl]="this.detailsGroup.controls.firstname"
                  class="w-full"></pf-text-input>
                </div>
              }
            </div>
            <div class="Frame798 grow shrink basis-0 h-20 justify-start items-start flex w-full">
              <div
                class="Frame793 grow shrink basis-0 h-20 pt-3  border-b border-zinc-200 justify-start items-start gap-2.5 flex">
                <pf-text-input label="{{'PARKIFLY.FORM.LAST_NAME' | transloco}}"
                [inputFormControl]="this.detailsGroup.controls.lastname" class="w-full"></pf-text-input>
              </div>
            </div>
          </div>
          <div class="Frame800 self-stretch justify-start items-start flex flex-col lg:flex-row">
            <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex w-full">
              <div class="grow shrink basis-0 h-20 pt-3 justify-start items-start gap-2.5 flex lg:border-r lg:border-r-[zinc-200] border-b border-b-[zinc-200]"
                [ngClass]="{'lg:border-b lg:border-zinc-200' : (detailsGroup.controls.comment || detailsGroup.controls.bookingNumber ), 'lg:border-b-0' : (!detailsGroup.controls.comment && !detailsGroup.controls.bookingNumber) }">
                <pf-email-input-field icon="envelope" iconColor="fill-[#9CA3AF]"
                  label="{{'PARKIFLY.FORM.EMAIL' | transloco}}"
                  [inputFormControl]="this.detailsGroup.controls.email"
                class="w-full"></pf-email-input-field>
              </div>
            </div>
            <div class="Frame798 grow shrink basis-0 h-20 justify-start items-start flex w-full">
              <div class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex"
                [ngClass]="{'border-b' : (detailsGroup.controls.comment || detailsGroup.controls.bookingNumber), 'border-b-0' : (!detailsGroup.controls.comment && !detailsGroup.controls.bookingNumber) }">
                <pf-phone-number-input label="{{'PARKIFLY.FORM.PHONENUMBER' | transloco}}"
                  [inputFormControl]="this.detailsGroup.controls.cellular"
                class="w-full focus:ring-0"></pf-phone-number-input>
              </div>
            </div>
          </div>

          @if(detailsGroup.controls.comment) {
            <div class="Frame801 self-stretch justify-start items-start inline-flex">
              <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-text-input label="{{'PARKIFLY.FORM.COMMENT' | transloco}}"
                    [inputFormControl]="this.detailsGroup.controls.comment"
                  class="w-full focus:ring-0"></pf-text-input>
                </div>
              </div>
            </div>
          }

          @if(detailsGroup.controls.bookingNumber) {
            <div class="Frame801 self-stretch justify-start items-start inline-flex">
              <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-text-input (input)="bookingNrToUpper()"
                    label="{{'PARKIFLY.FORM.ORDER_NUMBER' | transloco}}"
                    [inputFormControl]="this.detailsGroup.controls.bookingNumber"
                  class="w-full focus:ring-0"></pf-text-input>
                </div>
              </div>
            </div>
          }

        </div>
      </div>

      @if(!showSubscription && (this.detailsGroup.controls.persons || this.detailsGroup.controls.onlyHandBaggage)) {

        <div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex">
          @if (detailsGroup.controls.persons || this.detailsGroup.controls.onlyHandBaggage) {
            <div
              class="DuOchDittResesLlskap text-black text-xl font-medium  leading-loose">
              {{'PARKIFLY.DETAILS.YOU_AND_COMPANY'
            | transloco}}</div>
          }
          <div
            class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
            <div class="Frame799 self-stretch justify-start items-start flex flex-col lg:flex-row">
              @if(optionsConfig?.luggage !== false) {
                <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex w-full">
                  <div
                    class="Frame793 grow shrink basis-0 h-20 border-r border-zinc-200 justify-start items-start flex">
                    <div
                      class="AntalVSkorAttCheckaIn grow pt-3 shrink basis-0 text-blue-900 text-sm font-medium  leading-none">
                      <pf-select label="{{'PARKIFLY.FORM.CHECKIN_BAGAGE' | transloco}}"
                        [inputFormControl]="this.detailsGroup.controls.onlyHandBaggage"
                        [options]="checkInBagage" class="w-full">
                      </pf-select>
                    </div>
                  </div>
                </div>
              }

              @if(this.detailsGroup.controls.persons) {

                <div class="Frame798 grow shrink basis-0 h-20 justify-start items-start flex w-full">
                  <div
                    class="Frame793 grow shrink basis-0 pt-3 h-20 border-zinc-200 justify-start items-start gap-2.5 flex">
                    <pf-select label="{{'PARKIFLY.FORM.PERSONS' | transloco}}"
                      [inputFormControl]="this.detailsGroup.controls.persons" [options]="passengers"
                    class="w-full"></pf-select>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <div class="Frame805 self-stretch flex-col justify-start items-start gap-4 flex">
        <div class="Biluppgifter text-black text-lg font-bold  leading-loose">{{'PARKIFLY.DETAILS.CAR_DETAILS' |
          transloco}}
        </div>

        <div
          class="Bagage self-stretch bg-neutral-50 rounded-xl border border-neutral-300 justify-start items-end inline-flex">
          <div
            class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
            <pf-text-input (input)="regToUpper()" label="{{'PARKIFLY.FORM.CARID' | transloco}}"
              [inputFormControl]="this.detailsGroup.controls.regNr" [minlength]="4" [maxlength]="9"
            class="w-full"></pf-text-input>
          </div>
        </div>

        @if(!showSubscription && this.parkType.toLowerCase() !== 'flygets p1 storbil') {
          <div class="Bagage self-stretch p-4 bg-neutral-50 rounded-xl border border-neutral-300 justify-start items-center gap-4 inline-flex h-[82px]"
            (click)="triggerParkingSpaceSize()">
            <div class="FormFieldsCheckboxInput w-4 h-4 relative" (click)="$event.stopPropagation()">
              <pf-checkbox [inputFormControl]="this.detailsGroup.controls.parkingspacesize"></pf-checkbox>
            </div>
            <div class="Frame539 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex mt-2">
              <div class="Checkbox justify-start items-center gap-2 inline-flex">
                @if(parkTypeForDisabled) {
                  <div class="Title text-blue-900 text-sm font-medium  leading-none">
                  {{'PARKIFLY.FORM.TERMS_DISABLED_PERMIT' | transloco }}</div>
                  }@else {
                  <div class="Title text-blue-900 text-sm font-medium  leading-none">
                    @if(!showHeightRequirement){
                      {{'PARKIFLY.FORM.TERMSPARKINGSPACESIZE' | transloco : {parkingSpotSize :
                      parkingSpaceSizeText} }}
                    } @else{
                      {{'PARKIFLY.FORM.TERMSPARKINGSPACESIZEANDHEIGHT' | transloco : {parkingSpotSize :
                      parkingSpaceSizeText} }}
                    }
                  </div>
                }
              </div>
              <div class="Checkbox justify-start items-center gap-2 inline-flex">
                @if( !parkTypeForDisabled ) {
                  <div class="Title text-blue-600 text-sm font-medium  leading-normal tracking-tight cursor-pointer hover:underline"
                    (click)="$event.stopPropagation();openHandBagageModal()">{{'PARKIFLY.FORM.READ_MORE' |
                    transloco}}
                  </div>
                }
              </div>
            </div>
          </div>
        }
        @if(!showSubscription && this.parkType.toLowerCase() !== 'flygets p1 storbil') {
          <div class="Frame539 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
            <div class="Checkbox justify-start items-center gap-2 inline-flex">
              @if(this.parkingTypeId !== '8d922482-7855-47dc-953b-b16f00e5e45a' ) {
                <div class="Title text-blue-600 text-sm font-medium  leading-normal tracking-tight cursor-pointer hover:underline"
                  (click)="$event.stopPropagation();openHandBagageModal()">{{'PARKIFLY.FORM.READ_MORE' |
                  transloco}}
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="Frame840 self-stretch h-64 flex-col justify-start items-start gap-4 flex">
        <div class="Frame806 self-stretch h-7 flex-col justify-start items-start gap-4 flex">
          <div class="Villkor text-black text-lg font-bold  leading-loose">{{'PARKIFLY.DETAILS.TERMS' |
            transloco}}
          </div>
        </div>

        @if (organizationId?.toLowerCase() == '942ce067-7848-4441-b746-8f6eed7395bb' || organizationId?.toLowerCase() == '55d7084d-3cf0-4ccc-9448-f924afcdf3bc') {
          <div
            class="Bagage self-stretch p-4 bg-neutral-50 rounded-xl border border-neutral-300 justify-start items-center gap-4 inline-flex h-[82px]"
            (click)="triggerHotelInfoConsent()">
            <div class="FormFieldsCheckboxInput w-4 h-4 relative" (click)="$event.stopPropagation()">
              <pf-checkbox [inputFormControl]="this.detailsGroup.controls.hotelInfoConsent"></pf-checkbox>
            </div>
            <div class="Frame539 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
              <div class="Checkbox justify-start items-center gap-2 inline-flex">
                <div class="Title text-blue-900 text-sm font-medium leading-none">
                  {{'PARKIFLY.FORM.QUALITY_CANCELLED_HOTEL_STAY' |
                  transloco}}
                </div>
              </div>
              <div class="Checkbox justify-start items-center gap-2 inline-flex">
                <div class="Title text-blue-600 text-sm font-medium leading-normal tracking-tight cursor-pointer hover:underline"
                  (click)="$event.stopPropagation(); openHotelInfoModal()">
                  {{'PARKIFLY.FORM.READ_MORE' |
                  transloco}}
                </div>
              </div>
            </div>
          </div>
        }

        <div class="Bagage self-stretch p-4 bg-neutral-50 rounded-xl border border-neutral-300 justify-start items-center gap-4 inline-flex h-[82px]"
          (click)="triggerConsent()">
          <div class="FormFieldsCheckboxInput w-4 h-4 relative" (click)="$event.stopPropagation()">
            <pf-checkbox [inputFormControl]="this.detailsGroup.controls.consent"></pf-checkbox>
          </div>
          <div class="Frame539 grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
            <div class="Checkbox justify-start items-center gap-2 inline-flex">
              <div class="Title text-blue-900 text-sm font-medium leading-none">{{'PARKIFLY.FORM.TERMS' |
                transloco}}
              </div>
            </div>
            <div class="Checkbox justify-start items-center gap-2 inline-flex">
              <div class="Title text-blue-600 text-sm font-medium leading-normal tracking-tight cursor-pointer hover:underline"
                (click)="$event.stopPropagation(); openTermsModal();">{{'PARKIFLY.FORM.READ_MORE' |
                transloco}}
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  }
  <div class="flex-col basis-1/3 w-full">
    <app-summary></app-summary>

  </div>
</div>